
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2023-04-02-the-good-father-japan-under-hypnosis",
      function () {
        return require("private-next-pages/blogs/2023-04-02-the-good-father-japan-under-hypnosis/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2023-04-02-the-good-father-japan-under-hypnosis"])
      });
    }
  